// extracted by mini-css-extract-plugin
module.exports = {"popup":"Help_popup__3ig8S","icon__wrapper":"Help_icon__wrapper__3tP5-","btn":"Help_btn__3ZW7P","message":"Help_message__2NWUm","show":"Help_show__CcYYs"};